import { KIZEN_PREFIX, LocalStorage } from './Storage';

const LANGUAGE_KEY = `${KIZEN_PREFIX}language`;

export const languageLocalStorage = new LocalStorage(LANGUAGE_KEY);
